<template>
    <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path fill="#fff" d="M66 56h75v90H66z"/>
            <path fill="#033D89" d="M100 0C44.842 0 0 44.842 0 100s44.842 100 100 100 100-44.842 100-100S155.158 0 100 0zm32.21 105.053L85.054 136.42c-4 2.738-9.474-.21-9.474-5.053V68.63c0-4.841 5.474-7.789 9.474-5.053l47.158 31.37c3.578 2.315 3.578 7.79 0 10.106z" fill-rule="nonzero"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconPlayHover',
};
</script>
